export const RESOURCE_TYPE_NEXTGEN_BACKLOG_REST_RESOURCE = 'NEXTGEN_BACKLOG_REST';
